import type React from "react";
import {Tooltip} from "@mui/material";
import {Tag} from "~/components/tag/Tag.tsx";
import type {ContractLifecycle} from "../contractExplorerTypes.ts";
import {LIFECYCLE_COLOR, LIFECYCLE_LABEL, LIFECYCLE_NOTE} from "../contractExplorerTypes.ts";

export const LifecycleTag: React.FC<{lifecycle: ContractLifecycle}> = ({lifecycle}) => (
    <Tooltip arrow title={LIFECYCLE_NOTE[lifecycle]}>
        <span><Tag label={LIFECYCLE_LABEL[lifecycle]} color={LIFECYCLE_COLOR[lifecycle]}/></span>
    </Tooltip>
);
